import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { rangeValuesForView } from '../helpers';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';

export const ALTERNATIVE_DICE_ANIMATION_DURATION = 1000;
export const ALTERNATIVE_DICE_TURBO_ANIMATION_DURATION = 0;

export const ALTERNATIVE_DICE_RANGE_TYPE = {
  IN: 0,
  OUT: 1,
};
export const ALTERNATIVE_DICE_RANGE_LIMIT_OPTIONS = {
  min: 1,
  max: 9999,
  minValueBetween: 0,
};
export const DEFAULT_MULTIPLIER_LIMITS = {
  minBet: 1.01,
  maxBet: 10000 * userInfoStore.rtp,
};

export const ALTERNATIVE_DICE_MARKET_TYPE = {
  In: 0,
  Out: 1,
};

export const ALTERNATIVE_DICE_RANGE_FROM = 0;
export const ALTERNATIVE_DICE_RANGE_TO = 1;

export const ALTERNATIVE_DICE_DEFAULT_RANGE_VALUE = {
  [ALTERNATIVE_DICE_RANGE_FROM]: 2500,
  [ALTERNATIVE_DICE_RANGE_TO]: 7500,
};

export const ALTERNATIVE_DICE_MAX_RANGE_VALUE_PERCENT = 100;
export const ALTERNATIVE_DICE_DEFAULT_MULTIPLIER_VALUE = 1.92;
export const ALTERNATIVE_DICE_RTP = 0.98;
export const ALTERNATIVE_DICE_MULTIPLIER_PRECISION = 4;
export const ALTERNATIVE_DICE_WIN_CHANCE_PRECISION = 6;
export const ALTERNATIVE_DICE_HIGH_LOW_PRECISION = 0;
export const ALTERNATIVE_DICE_WIN_CHANCE_STEP_VALUE = 1;
export const ALTERNATIVE_DICE_MULTIPLIER_STEP_VALUE = 2;
export const ALTERNATIVE_DICE_MULTIPLIER_MAX_LENGTH = 7;
export const ALTERNATIVE_DICE_WIN_CHANCE_MAX_LENGTH = 7;
export const ALTERNATIVE_DICE_HIGH_LOW_INPUT_MAX_LENGTH = 4;
export const ALTERNATIVE_DICE_MULTIPLIER_LIMIT = {
  minBet: 1.01,
  maxBet: 9900,
};

export const ORIGINAL_DICE_MULTIPLIER_MIN = 1.01021;

export const ALTERNATIVE_DICE_WIN_CHANCE_LIMIT = {
  minBet: 1.01,
  maxBet: 97.029702,
};

export const ALTERNATIVE_DICE_HIGH_LOW_LIMIT = {
  minBet: 1,
  maxBet: 9999,
};

export const ALTERNATIVE_DICE_GAME_ID = 47;

export const ALTERNATIVE_DICE_RANGE_SIDE = {
  From: 0,
  To: 1,
};

export const AlternativeDiceLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: 'bombCount',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <span className='cpt-table-text'>
        {rangeValuesForView({
          rangeType: spinInfo.spinData.spinMarket,
          from: spinInfo.spinData.from,
          to: spinInfo.spinData.to,
        })}
        {/* {t(ALTERNATIVE_DICE_RANGE_TYPE[spinInfo.spinData.spinMarket])} {spinInfo.spinData.number} */}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const AlternativeDiceBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: 'market_type',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <span className='cpt-table-text'>
        {rangeValuesForView({
          rangeType: spinInfo.spinMarket,
          from: spinInfo.from,
          to: spinInfo.to,
        })}
        {/* {t(ALTERNATIVE_DICE_RANGE_TYPE[spinInfo.spinData.spinMarket])} {spinInfo.spinData.number} */}
      </span>
    ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const ALT_DICE_RULES_KEYS = new Array(isPG() ? 19 : 11)
  .fill(null)
  .map((item, index) => index + 1);
export const ALT_DICE_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
